import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Row,
  Col,
  Spin,
  Form,
  Button,
  Modal,
  // message,
  // Input,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';
import ModalDelete from 'components/ModalDelete';
import API from 'utils/api';
// import fetchSome from 'utils/fetchSome';
import { onError, onSuccess } from 'utils/handlers';
// import getFormattedValues from 'utils/formatValues';
import Select from 'components/Select';
import { isMutable } from 'utils/estadosGlobales';
import NumericInput from 'components/NumericInput';

const currentURI = window.location.href.split('/').pop();
const baseURI = `configuraciones/${currentURI}`;

function DatosPago({ clave }) {
  const estadosGlobales = useSelector(({ catalogs }) => catalogs.estadosGlobales);
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [metodosPago, setMetodosPago] = useState([]);
  const [bancos, setBancos] = useState([]);

  const [mutable, setMutable] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      if (clave?.length) {
        const res = await API.get(baseURI, {
          params: {
            clave,
          },
        });
        setData(res.data);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const fetchAll = async () => {
    try {
      setLoading(true);
      const resMetodosPago = await API.get('/catalogos/metodos-de-pago/');
      setMetodosPago(resMetodosPago.data);
      const resBancos = await API.get('/configuraciones/bancos');
      setBancos(resBancos.data);

      await fetchData();
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    fetchAll();
    return () => API.tryCancel;
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    form.resetFields();
    setVisible(false);
    setMutable(true);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      if (!selectedRowKeys.length) {
        const res = await API.post(baseURI, values);
        if (res?.status === 201) {
          onSuccess(res, 'Agregado correctamente');
          onCancel();
          await fetchData();
        }
      } else {
        const [key] = selectedRowKeys;
        const res = await API.put(`${baseURI}${key}/`, values);
        if (res?.status === 200) {
          onSuccess(res, 'Actualizado correctamente');
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const response = await API.delete(`${baseURI}${key}/`);
        if (response?.status === 204) {
          onSuccess(response, 'Eliminado correctamente');
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
    setMutable(isMutable(record));
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Forma De Pago',
      dataIndex: 'forma_de_pago',
      key: 'forma_de_pago',
      width: 250,
      render: (val) => (metodosPago.find((e) => e.id === val)?.concepto),
    },
    {
      titleText: 'Banco',
      dataIndex: 'banco',
      key: 'banco',
      width: 250,
      render: (val) => (bancos.find((e) => e.id === val)?.nombre),
    },
    {
      titleText: 'Cuenta',
      dataIndex: 'cuenta',
      key: 'cuenta',
      width: 250,
    },
    {
      titleText: 'CLABE',
      dataIndex: 'clabe',
      key: 'clabe',
      width: 250,
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 250,
      render: (val) => (estadosGlobales.find((e) => e.id === val)?.descripcion),
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  const onClickEdit = () => {
    setVisible(true);
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          loading={loading}
          controls={{
            onClickAdd,
            onClickEdit,
            onClickDelete,
          }}
          mobileColIndex={0}
        />
        <Modal
          visible={visible}
          title={(
            <FormSubmitControls
              label={`${!selectedRowKeys.length ? 'Agregar' : 'Editar'} Datos De Pago`}
              onFinish={onFinish}
              onCancel={onCancel}
              mutable={mutable}
            />
            )}
          onCancel={onCancel}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
        >
          <Form
            name="general"
            form={form}
            layout="vertical"
            onFinish={onFinish}
            scrollToFirstError
            initialValues={{ estados_globales: 1 }}
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="Forma De Pago"
                  name="forma_de_pago"
                  rules={rules.required}
                >
                  <Select dataSource={metodosPago} labelProp="concepto" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="Bancos"
                  name="banco"
                  rules={rules.required}
                >
                  <Select dataSource={bancos} labelProp="nombre" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <NumericInput
                  name="cuenta"
                  label="Cuenta"
                  allowZero
                  required
                />
              </Col>
              <Col xs={24} sm={24} md={8}>
                <NumericInput
                  name="clabe"
                  label="CLABE"
                  allowZero
                  required
                />
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="Estado"
                  rules={rules.required}
                  name="estados_globales"
                  hasFeedback
                >
                  <Select
                    dataSource={estadosGlobales}
                    disabled={!selectedRowKeys.length || !mutable}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Row>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          visible={visibleAlert}
          content="El origen seleccionado"
          loading={loading}
        />
      </Spin>
    </Row>
  );
}

DatosPago.propTypes = {
  clave: PropTypes.number.isRequired,
};

export default DatosPago;
